import { render, staticRenderFns } from "./ChangeDepartmentDialog.vue?vue&type=template&id=609b7be8&"
import script from "./ChangeDepartmentDialog.vue?vue&type=script&lang=js&"
export * from "./ChangeDepartmentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports